import frBBA from '@/lang/fr/bba'
import frGlobal from '@/lang/fr/global'
import frConst from '@/lang/fr/const'
import frBooking from '@/lang/fr/booking'
import frCompany from '@/lang/fr/company'
import frError from '@/lang/fr/error'
import frEvent from '@/lang/fr/event'
import frGroup from '@/lang/fr/group'
import frHelp from '@/lang/fr/help'
import frHome from '@/lang/fr/home'
import frHotel from '@/lang/fr/hotel'
import frLightbox from '@/lang/fr/lightbox'
import frLocation from '@/lang/fr/location'
import frMessage from '@/lang/fr/message'
import frNews from '@/lang/fr/news'
import frNotification from '@/lang/fr/notification'
import frOffline from '@/lang/fr/offline'
import frOnline from '@/lang/fr/online'
import frSeminar from '@/lang/fr/seminar'
import frTraveller from '@/lang/fr/traveller'
import frUser from '@/lang/fr/user'
import frBBAContact from '@/lang/fr/bbacontact'
import frSurvey from '@/lang/fr/survey'
import frStats from '@/lang/fr/stats'
import frBookingInputFields from '@/lang/fr/bookinginputfield'
import frCompanyFavorites from '@/lang/fr/companyfavorite'
import frMailLog from '@/lang/fr/maillog'
import frMailTpl from '@/lang/fr/mailtpl'
import frConfiguration from '@/lang/fr/configuration'
import frCbConfiguration from '@/lang/fr/cbConfiguration'
import frBandeauConfiguration from '@/lang/fr/bandeauConfiguration'
import frZone from '@/lang/fr/zone'
import frTravelPolicy from '@/lang/fr/travelPolicy'
import frFormation from '@/lang/fr/formation'
import frFieldsWhiteMark from '@/lang/fr/fieldsWhiteMark'
import frContingentsHotel from '@/lang/fr/contingent_hotel'
import frHotelGamme from '@/lang/fr/hotelGamme'
import frConfigContingent from '@/lang/fr/configContingent'
import frHotelRetrocession from '@/lang/fr/hotelretrocession'
import frRetrocession from '@/lang/fr/retrocession'
import frContingentBooking from '@/lang/fr/contingentBooking'
import frContingent from '@/lang/fr/contingent'

export default {
  fr: Object.assign(
    {},
    frBBA,
    frGlobal,
    frConst,
    frBooking,
    frCompany,
    frError,
    frEvent,
    frGroup,
    frHelp,
    frHome,
    frHotel,
    frLightbox,
    frLocation,
    frMessage,
    frNews,
    frNotification,
    frOnline,
    frOffline,
    frSeminar,
    frTraveller,
    frUser,
    frBBAContact,
    frSurvey,
    frStats,
    frBookingInputFields,
    frCompanyFavorites,
    frMailLog,
    frMailTpl,
    frConfiguration,
    frCbConfiguration,
    frBandeauConfiguration,
    frZone,
    frTravelPolicy,
    frFieldsWhiteMark,
    frFormation,
    frContingentsHotel,
    frHotelGamme,
    frConfigContingent,
    frHotelRetrocession,
    frRetrocession,
    frContingentBooking,
    frContingent
  )
}
